<template>
    <section class="page-section" v-loading="pageLoading">
                
                <el-form size="small" :model="form" :rules="rules" label-width="110px" class="content-form no-padding-bottom pt20" ref="form">
                    <el-form-item label="员工姓名" prop="name">
                        <el-input class="w300" v-model="form.name" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="工作手机号" prop="mobile">
                        <el-input class="w300" v-model="form.mobile" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleCommit('form')" :loading="btnLoading">确定</el-button>
                        <el-button size="small" type="default" plain @click="handleback">取消</el-button>
                    </el-form-item>
                </el-form>
            </section>
</template>

<script>
import { agentEmployeeSaveOrUpdate } from '../../../common/api';

export default {
    data() {
        return {
            id: this.$route.query.id,
            form: {
                name: '',
                mobile: '',
            },

            pageLoading: false,
            btnLoading: false,

            rules: {
                name: [
                    { required: true, message: '请输入员工姓名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入工作手机号', trigger: 'blur' }
                ],
            }
        }
    },
    mounted() {
        let query = this.$route.query
        if (query.id) {
          const { name, mobile } = query.row
          Object.assign(this.form, {
            name,
            mobile
          })
        }
    },
    methods: {
        /**
         * [handleCommit description] 提交
         * @param  {[type]} formName [description]
         * @return {[type]}          [description]
         */
        handleCommit: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    const { name, mobile } = this.form
                    let param = {
                        name,
                        mobile
                    }

                    if(this.id) {
                        param.id = this.id;
                    }
                    if(localStorage.getItem('companyId') && localStorage.getItem('companyId') != 'null') {
                        param.companyId = localStorage.getItem('companyId')
                    }

                    agentEmployeeSaveOrUpdate(param).then(res =>{
                        this.btnLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            this.$message.success('保存成功');
                            this.handleback()
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.btnLoading = false;
                        this.$message.error('服务器异常');
                    });
                    
                } else {
                    return false;
                }
            });
        },
        /**
         * [handleback description] 取消-返回列表
         * @return {[type]}          [description]
         */
        handleback: function() {
            this.$router.push('/agent/employee/list');
        },
    }
}
</script>

<style lang="scss" scoped>
</style>

